import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

interface PromotionItem {
  id: number;
  image: string;
  title: string;
  description: string;
  link: string;
}

const promotionItems: PromotionItem[] = [
  {
    id: 1,
    image: "/lovable-uploads/eadadccc-a4de-47a5-b529-8c6591358330.png",
    title: "عطورنا التقليدية",
    description: "بخور وعطور وفن - تراث يمني أصيل وجودة فائقة",
    link: "https://www.instagram.com/arousat.aden"
  },
  {
    id: 2,
    image: "/lovable-uploads/43d5b2fb-ca50-4130-bbf4-577d4681fe59.png",
    title: "هدايا الزفاف",
    description: "باقات خاصة للعروس من أفخم العطور والبخور المميزة",
    link: "https://www.instagram.com/arousat.aden"
  },
  {
    id: 3,
    image: "/lovable-uploads/74025112-29b1-4a98-8fc3-0ff1c1b77690.png",
    title: "عروض خاصة",
    description: "خصومات تصل إلى ٥٠٪ على منتجات مختارة - عروض محدودة",
    link: "https://www.instagram.com/arousat.aden"
  }
];

const FeaturedProducts = () => {
  return (
    <section id="products" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">
            <span className="text-brand-pink">اكتشف عالم</span>{" "}
            <span className="text-brand-black">عطورنا الفاخرة</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            عطور يمنية تقليدية مميزة للمناسبات الخاصة والأعراس
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {promotionItems.map((item) => (
            <Card key={item.id} className="overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow">
              <div className="aspect-square bg-gray-100">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <Button 
                  asChild
                  className="bg-brand-pink hover:bg-brand-pink/90 text-white rounded-full"
                >
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    اكتشف المزيد
                  </a>
                </Button>
              </div>
            </Card>
          ))}
        </div>
        
        {/* Removed the "تسوق الآن" button and its container div */}
      </div>
    </section>
  );
};

export default FeaturedProducts;
